import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { REFRESH_HOLDINGS_MODAL_STATE_SLICE_KEY, refreshHoldingsModal } from './state/refresh-holdings-modal.reducer';
import { AccountIntegrationsModule } from 'AccountsApp/ts/apps/account-integrations-app/app.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { SimplePaginationControlsModule } from 'NewAngular/features/components/pagination/simple-pagination-controls/simple-pagination-controls.module';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class RefreshHoldingsModalModule {
}
RefreshHoldingsModalModule.ɵfac = function RefreshHoldingsModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RefreshHoldingsModalModule)(); };
RefreshHoldingsModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RefreshHoldingsModalModule });
RefreshHoldingsModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        LoadingSymbolModule,
        ModalBaseModule,
        SimplePaginationControlsModule,
        AccountIntegrationsModule,
        StoreModule.forFeature(REFRESH_HOLDINGS_MODAL_STATE_SLICE_KEY, refreshHoldingsModal)] });
